const generateNotificationId = () => {
  // https://gist.github.com/gordonbrander/2230317#gistcomment-1713405
  return (Date.now().toString(36) + Math.random().toString(36).substr(2, 5)).toUpperCase();
};

export default generateNotificationId;
